import moment from "moment";

const RESERVATION = "RESERVATION";
const CLIENT_INFORMATION = "CLIENT_INFORMATION";
const CONFIRMATION = "CONFIRMATION";
const SPLIT_RESERVATION = "SPLIT_RESERVATION";

function defaultState() {
    return {
        boardingId: null, // the value existed only for edit mode
        session: null,
        isProceedSplit: false,
        isLoadingFooterPreview: false,
        modalTitle: "",
        isEditMode: false,
        currentView: RESERVATION,
        roomList: [],
        bookings: [], // array of bookingInfo objects. why? because split function can create multiple bookings
        checkInTime: "00:00",
        checkOutTime: "00:00",
        isExternal: false,
        view: {
            RESERVATION: {
                selectedProvider: null,
                providerList: [],
                selectedClient: null,
                selectedPatient: null, // a.k.a guest
                patientList: [], // filtered based on client
                notes: "",
                dateCheckIn: null,
                dateCheckOut: null,
                selectedRoom: null
            },
            SPLIT_RESERVATION: {
                dateCheckIn: null,
                dateCheckOut: null,
                selectedRoom: null
            },
            CLIENT_INFORMATION: {
                firstName: "",
                lastName: "",
                address: "",
                zipcode: "",
                city: "",
                state: "",
                country: "",
                // birthDate: null, // date
                birthDate: "",
                email: "",
                driverLicense: "",
                phone: {
                    home: {
                        countryCode: "1",
                        number: ""
                    },
                    mobile: {
                        countryCode: "1",
                        number: ""
                    },
                    work: {
                        countryCode: "1",
                        number: ""
                    },
                    fax: {
                        countryCode: "1",
                        number: ""
                    }
                },
                reminders: [] // ie. Email, Phone, SMS etc
            },
            CONFIRMATION: {
                // typeList: [],
                confirmation: {
                    options: [],
                    selectedOption: 0,
                    message: ""
                },
                reminder: {
                    isEnabled: false,
                    options: [],
                    selectedOption: 4, // 4 = no reminder
                    message: "",
                    send: {
                        value: 1,
                        periodType: 4, // 4 = Days,
                        option: 1 // before/after due
                    }
                }
            }
        }
    };
}

const getters = {};

const actions = {
    registerBooking({ commit, state }, payload) {
        let bookings = [...state.bookings];

        let momentStart = moment.tz(payload.start, payload.timezone);
        let momentEnd = moment.tz(payload.end, payload.timezone);

        // generate unique id to prevent duplication
        let uniqueId = payload.roomId;
        uniqueId += "_" + momentStart.unix();
        uniqueId += "_" + momentEnd.unix();

        let booking = {
            roomId: payload.roomId,
            roomName: payload.roomName,
            start: payload.start,
            end: payload.end,
            uniqueId: uniqueId,
            startUnix: momentStart.unix(),
            endUnix: momentEnd.unix(),
            uniqueId2: state.session + "_" + bookings.length,
            isExternal: state.isExternal
        };

        bookings.push(booking);
        commit("setBookings", bookings);
    },
    applyClientData({ commit }, payload) {
        commit("setViewState", {
            view: CLIENT_INFORMATION,
            value: {
                firstName: payload.firstname,
                lastName: payload.lastname,
                address: payload.address,
                zipcode: payload.zipcode,
                city: payload.city,
                state: payload.state,
                country: payload.country,
                birthDate: payload.birthdate,
                email: payload.email,
                driverLicense: payload.driver_license,
                phone: {
                    home: {
                        countryCode: payload.home_country_code,
                        number: payload.home
                    },
                    mobile: {
                        countryCode: payload.mobile_country_code,
                        number: payload.mobile
                    },
                    work: {
                        countryCode: payload.work_country_code,
                        number: payload.work
                    },
                    fax: {
                        countryCode: payload.fax_country_code,
                        number: payload.fax
                    }
                },
                reminders: payload.reminderOptions
            }
        });
    }
};

const mutations = {
    setPatient(state, value) {
        state.view.RESERVATION.selectedPatient = value;
    },
    setBookings(state, value) {
        state.bookings = value;
    },
    setEditMode(state, value) {
        state.isEditMode = value;
    },
    setIsExternal(state, value) {
        state.isExternal = value;
    },
    setModalTitle(state, value) {
        state.modalTitle = value;
    },
    setCurrentView(state, value) {
        state.currentView = value;
    },
    reset(state) {
        let newState = defaultState();
        for (let key in state) {
            state[key] = newState[key];
        }
    },
    setViewState(state, payload = {}) {
        state.view[payload.view] = payload.value;
    },
    setRoomList(state, value = []) {
        state.roomList = value;
    },
    clearSplitForm(state) {
        state.view.SPLIT_RESERVATION = {
            dateCheckIn: null,
            dateCheckOut: null,
            selectedRoom: null
        };
    },
    setTime(state, payload = {}) {
        state.checkInTime = payload.checkIn;
        state.checkOutTime = payload.checkOut;
    },
    proceedSplit(state, value) {
        state.isProceedSplit = value;
    },
    setSession(state, value) {
        state.session = value;
    },
    setIsLoadingDetails(state, value) {
        state.isLoadingFooterPreview = value;
    },
    setBoardingId(state, value) {
        state.boardingId = value;
    }
};

export default {
    namespaced: true,
    state: defaultState(),
    getters,
    actions,
    mutations,
    views: {
        RESERVATION,
        CLIENT_INFORMATION,
        CONFIRMATION,
        SPLIT_RESERVATION
    }
};
